import React from "react";
import { ReactComponent as BenchSvg } from "../svg/bench.svg";

export default function BenchIcon({ size = 64, color = "#32363F", ...props }) {
  return <BenchSvg width={size} height={size} style={{ color }} {...props} />;
}
